import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { DictionaryUnitStateListParams } from './models/unit-state-list-params';
import { Dictionary } from '../../../shared/models/dictionary';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryUnitStateService
  extends StoreBaseService<Dictionary, Dictionary, DictionaryUnitStateListParams> {

  get entityType(): string {
    return EntityTypes.unitState;
  }

  get resourceName(): string {
    return 'unit-state';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
